// Distribuciones de la OT (pre-guías por local) emitidas como guías de despacho masivas (Facturación.cl)

export const DISTRIBUTION_STATUS = {
  borrador: { text: 'Borrador', color: 'grey' },
  en_emision: { text: 'En emisión', color: 'primary' },
  parcial: { text: 'Parcial', color: 'info' },
  emitida: { text: 'Emitida', color: 'success' },
}

export function facturacionClEnabled(vm) {
  return !!(vm.$store.getters.getCompany && vm.$store.getters.getCompany.facturacioncl_integration_enabled)
}

// Emitir (start/resume/pause/stop) es del área de facturación; gestionar la distribución, de quien ve la cotización/OT
export function canEmitDispatch(vm) {
  return facturacionClEnabled(vm) && vm.$can('read', 'Invoice')
}
